import {
  PersonIcon,
  LogoutIcon,
  WarrantyShieldIcon,
  BusinessIcon,
} from "@talladega/icons";
import CustomerAvatar from "@components/CustomerAvatar";
import Link from "next/link";
import { User } from "@modules/user/types/user";
import { useTranslation } from "next-i18next";
import { Purchase } from "@modules/purchase/warranty/types/Purchase";
import { aftermarketQuoteStep } from "@modules/purchase/PurchaseStep";
import { getStepById as consumerGetStepById } from "@modules/purchase/consumer/types/ConsumerFinancingStep";
import useConsumerFinancing from "@modules/purchase/consumer/hooks/useConsumerFinancing";
import { tryGetActiveConsumerFinancingPurchase } from "@modules/purchase/consumer/types/ConsumerFinancing";

type Props = {
  user: User;
  activePurchase: Purchase | undefined;
  onLogoutClick: () => void;
};

const AvatarMenu = ({ user, activePurchase, onLogoutClick }: Props) => {
  const showWarrantyProtectionMenu =
    activePurchase && activePurchase.currentStepId !== aftermarketQuoteStep.id;

  const { consumerFinancing: consumerFinancingOrNotFound } =
    useConsumerFinancing();

  const consumerFinancingPurchase = tryGetActiveConsumerFinancingPurchase(
    consumerFinancingOrNotFound
  );

  const financingPurchaseStep =
    consumerFinancingPurchase?.currentStepId != null
      ? consumerGetStepById(consumerFinancingPurchase.currentStepId)
      : null;

  const showConsumerFinancingMenu =
    !!consumerFinancingPurchase && !!financingPurchaseStep;

  const { t } = useTranslation(["common", "purchase"]);
  return (
    <div className="hidden lg:block bg-white rounded-md fixed right-12 xl:right-32 border border-secondary shadow-lg text-sm">
      <div className="flex flex-row items-center border-b p-4">
        <div className="pr-4">
          <CustomerAvatar customer={user} size="md" isCurrentUser />
        </div>
        <div>
          <p className="font-semibold">
            {user.firstName} {user.lastName}
          </p>
          <p>{user.email}</p>
        </div>
      </div>
      <div className="p-4 font-semibold flex flex-col gap-4">
        <div className="text-black">
          <Link href="/profile">
            <div className="flex flex-row gap-4 items-center">
              <PersonIcon className="h-6 w-6" />
              <span>{t("common:my_profile")}</span>
            </div>
          </Link>
        </div>
        {showWarrantyProtectionMenu && (
          <div>
            <Link href="/protection">
              <div className="flex flex-row gap-4 items-center">
                <WarrantyShieldIcon className="h-6 w-6 text-white" />
                <span>{t("purchase:my_warranty")}</span>
              </div>
            </Link>
          </div>
        )}
        {showConsumerFinancingMenu && (
          <div>
            <Link href="/my-financing">
              <div className="flex flex-row gap-4 items-center">
                <BusinessIcon className="h-6 w-6 " />
                <span>{t("purchase:my_financing")}</span>
              </div>
            </Link>
          </div>
        )}
        <div>
          <Link href="#" onClick={onLogoutClick}>
            <div className="flex flex-row gap-4 items-center">
              <LogoutIcon className="h-6 w-6 text-[#C24040]" />
              <span>{t("common:logout")}</span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AvatarMenu;
